export default __webpack_public_path__ + "static/media/img-intro-choice-1-crypto@3x.5f73dc09.png";